module.exports = __webpack_public_path__ + "static/media/diffcult_icon.f5aee2fc.png";